import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';

import { useTranslate } from '@growtherapy/i18n';
import { DrawerBody, DrawerHeader, IconButton, Text, cn } from '@growtherapy/sprout-ui';

import { useTheme } from '../../hooks';
import { Theme } from '../../state';

export function ReflectionTopicsDrawer({
  title,
  content,
  onClickBackButton,
}: {
  title: string;
  content: React.ReactNode;
  onClickBackButton?: () => void;
}) {
  const t = useTranslate();
  const { theme } = useTheme();
  const isDarkTheme = theme === Theme.DARK;
  return (
    <>
      <DrawerHeader>
        <div className='flex items-center'>
          {onClickBackButton && (
            <IconButton
              onClick={onClickBackButton}
              className='mr-4 w-8 h-8 flex justify-center items-center'
              iconSize='xs'
              aria-label={t('telehealth-core:core.goBack')}
              data-testid='reflection-topics.button.back'
              iconDefinition={faArrowLeft}
            />
          )}
          <Text as='h2' variant='lg' className={cn('fs-exclude', { 'rebrand:text-text-inverse': isDarkTheme })}>
            {title}
          </Text>
        </div>
      </DrawerHeader>
      {/* NOTE: Padding is set by the content itself, as certain views want to take up the full interior of the drawer. */}
      <DrawerBody className='!p-0'>{content}</DrawerBody>
    </>
  );
}
